import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DxCheckBoxModule, DxValidatorModule } from 'devextreme-angular';
import { ValidationRule } from 'devextreme-angular/common';

@Component({
  selector: 'form-checkbox',
  templateUrl: './form-checkbox.component.html',
  styleUrls: ['form-checkbox.component.scss'],
  imports: [DxCheckBoxModule, DxValidatorModule]
})
export class FormCheckboxComponent {
  @Input() isEditing = false;
  @Input() text = '';
  @Input() validators: ValidationRule[];
  @Input() value!: boolean;

  @Output() valueChange = new EventEmitter<any>();
  valueChanged(e) {
    this.valueChange.emit(e.value);
  }
}
